// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3B5LS","inputWrap":"CustomTip_inputWrap__11Alo"};